import { Box } from "@mui/material";
import CustomShimmer from "../../../components/CustomShimmer/CustomShimmer";
import { Colors } from "../../../styles/constant";

interface Props {
  backgroundColor?: string;
}

const TopBannerSkeleton: React.FC<Props> = ({
  backgroundColor = Colors.white,
}) => {
  return (
    <Box
      padding="1rem"
      sx={{ backgroundColor: backgroundColor }}
      borderRadius="1rem"
    >
      <CustomShimmer width="75%" height="1rem" borderRadius="0.5rem" />
      <CustomShimmer
        width="60%"
        height="1rem"
        borderRadius="0.5rem"
        sx={{ marginTop: ".625rem" }}
      />
      <CustomShimmer
        width="9rem"
        height="2.5rem"
        sx={{ marginTop: "1rem" }}
        borderRadius="2rem"
      />
    </Box>
  );
};

export default TopBannerSkeleton;
